import type { SVGProps } from "react";
const SvgTelegram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 25 25"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.617 11.38Q11.44 7.972 14.05 6.886c4.968-2.066 6-2.425 6.673-2.437.148-.002.479.034.693.208.181.147.23.346.255.485s.053.456.03.704c-.27 2.829-1.434 9.693-2.027 12.861-.25 1.34-.745 1.79-1.223 1.834-1.038.096-1.827-.686-2.834-1.346-1.574-1.032-2.464-1.674-3.992-2.681-1.766-1.164-.621-1.804.386-2.85.263-.273 4.84-4.436 4.929-4.814.01-.047.021-.223-.084-.316-.104-.093-.259-.062-.37-.036q-.237.054-7.546 4.987-1.07.736-1.94.717c-.638-.014-1.867-.361-2.78-.658-1.12-.364-2.011-.557-1.934-1.175q.06-.484 1.331-.989"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTelegram;
